import { makeStyles } from 'tss-react/mui';

const DashboardStyles = makeStyles()((theme) => {
    return {
        iframe: {
            position: 'fixed',
            border: 'none',
            top: 100,
            right: 0,
            bottom: 0,
            left: 0,
            width: '100%',
            height: '75%',
            paddingTop: 'inherit',
        },
        subnav: {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            paddingTop: 15,
            paddingBottom: 15,
        },
        granted: {
            color: theme.palette.primary.main,
        },
        requested: {
            color: '#ff6c80',
        },
        navButton: {
            width: '100%',
        },
        snackbarContent: {
            backgroundColor: theme.palette.background.paper,
        },
        snackbarOverwrite: {
            minWidth: '0px !important',
            backgroundColor: theme.palette.background.paper,
        },
        anchorOverwrite: {
            right: '60px !important',
            bottom: '15px !important',
        },
    };
});

export default DashboardStyles;
